// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionM_comp___fJR_"};